import { InputWithOptionsUniDriver } from '../InputWithOptions/InputWithOptions.uni.driver';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface MultiSelectCheckboxUniDriver extends Omit<
  InputWithOptionsUniDriver,
  'driver'
> {
  driver: {
    getNumOfLabels: () => Promise<number>;
    getLabels: (delimiter?: string) => Promise<string[]>;
    getLabelAt: (index: number, delimiter?: string) => Promise<string>;
  } & Pick<InputWithOptionsUniDriver, 'driver'> &
    BaseUniDriver;
}
